import { styled, TextButton } from '~/app/components'
import React, { Dispatch, FC, SetStateAction } from 'react'
import { Icon_arrowmore_fill } from '@yanolja-rnd/ya-com-system-icon'
import { Typography } from '@yanolja-rnd/ya-com-core'

const PriceDetail = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0.7rem 2rem 0.7rem 0;
  color: ${({ theme }) => theme.color.yablue};
  ${Typography('body2').regular};
  cursor: pointer;
`
const Title = styled.div`
  display: flex;
  align-items: center;
`
const IconWrap = styled.span<{ isShowMore: boolean }>`
  margin: 0.4rem 0 0 0.2rem;

  > svg {
    transition: transform 0.2s ease;
    ${({ isShowMore }) => isShowMore && 'transform: rotate(180deg)'};
    path {
      fill: ${({ theme }) => theme.color.gray900};
    }
  }
`

type ShowPriceDetailProps = {
  isShow: boolean
  setIsShow: Dispatch<SetStateAction<boolean>>
}

const ShowPriceDetail: FC<ShowPriceDetailProps> = ({ isShow, setIsShow }) => {
  return (
    <PriceDetail>
      <TextButton
        type={'basic'}
        typography={'body2'}
        title={
          <Title>
            {isShow ? '간단히 보기' : '금액 자세히 보기'}
            <IconWrap isShowMore={isShow}>
              <Icon_arrowmore_fill size={1.2} unit="rem" />
            </IconWrap>
          </Title>
        }
        preventDoubleTab={{ enabled: false, delay: 0 }}
        onClick={() => setIsShow(state => !state)}
      />
    </PriceDetail>
  )
}

export default ShowPriceDetail
